<template>
	<!-- 机器人 -->
	<div>
		<div class="service" @click="isKf"><img src="../../static/images/jiqiren.png"></div>
		<div class="service-tk" v-if="isKfjqr">
			<img src="../../static/images/jiqiren.png" class="jqr">
			<button><img src="../../static/images/close.png" class="close" @click="close"></button>
			<h2>欢迎合作、软件开发咨询</h2>
			<h2>dyds8521</h2>
			<div class="jwxq">
				<img src="../../static/images/words.png">
				<span>weChat</span>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data () {
			return {
			  isKfjqr:false
			}
		},
		methods:{
			isKf(){
				this.isKfjqr = true
			},
			close(){
				this.isKfjqr = false
			}
		}
	}
</script>

<style scoped>
.service{position: fixed;width: 1.92rem;height: 2rem;right: 1.08rem;bottom: 1.07rem;cursor: pointer;}
.service img{width: 100%;height: 100%;}
.service-tk{position: fixed;top: 50%;left: 50%;width: 4rem;height: 4.01rem;background-color: #FFFFFF;box-shadow:0px .07rem .3rem .02rem rgba(216,218,221,0.5);margin-left: -2rem;margin-top: -2rem;text-align: center;}
.service-tk .jqr{width:1.32rem;height:1.38rem;margin: .30rem auto 0;display: block;}
.service-tk .close{width: .16rem;height: .17rem;position: absolute;top: .17rem;right: .17rem;}
.service-tk .close img{width: 100%;}
.service-tk h2{font-size: .26rem;font-weight: bold;margin-top: .3rem;}
.service-tk p{color: #666666;font-size: .16rem;margin-top: .29rem;display: block;}
.service-tk .jwxq{width: 100%;height: .88rem;margin-top: .34rem;background-color: #4C86FC;display: flex;justify-content: center;}
.service-tk .jwxq img{width: .43rem;height: .42rem;margin: .23rem;margin-left:-.23rem;}
.service-tk .jwxq span{color: #FFFFFF;font-size: .22rem;line-height: .88rem;}
</style>



// WEBPACK FOOTER //
// src/components/service.vue